module.exports = __webpack_public_path__ + "img/first_bg_b.81d7d61.png";